<template>
  <aside class="admin-sidebar" :class="{ open }">
    <div class="sidebar-brand">
      <img src="/svqt_images/logo/logo.png" alt="SVQT" onerror="this.style.display='none'" />
      <span>SVQT<br />Admin panel</span>
    </div>
    <ul class="sidebar-nav">
      <li v-for="link in links" :key="link.to">
        <router-link class="sidebar-link" :to="link.to" @click="$emit('navigate')">
          <i class="bi" :class="link.icon"></i>
          {{ link.label }}
        </router-link>
      </li>
    </ul>
  </aside>
</template>

<script setup>
defineProps({ open: Boolean });
defineEmits(["navigate"]);

const links = [
  { to: "/", label: "Boshqaruv paneli", icon: "bi-speedometer2" },
  { to: "/about", label: "Biz haqimizda", icon: "bi-info-circle" },
  { to: "/news", label: "Yangiliklar", icon: "bi-newspaper" },
  { to: "/teatr", label: "Spektakllar", icon: "bi-mask" },
  { to: "/team", label: "Jamoa", icon: "bi-people" },
  { to: "/gallery", label: "Galereya", icon: "bi-images" },
  { to: "/messages", label: "Xabarlar", icon: "bi-chat-dots" },
];
</script>
